
import Swiper from '~/components/swiper'
import LolePicture from '~/components/picture/lole-picture'
import LoleVideoPicture from '~/components/picture/lole-video-picture'
export default {
  components: { LolePicture, LoleVideoPicture, Swiper },
  props: {
    product: {
      type: Object,
      required: true,
    },
    medias: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      videoOnError: false,
    }
  },
}
